import Link from 'next/link';
import classNames from 'classnames';
import { PreviewExercise } from '@models/exercise';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { FunctionComponent } from 'react';

interface Props {
  exercise: PreviewExercise;
  state: 'done' | 'undone';
  index: number;
  link: string;
}

const CardExercise: FunctionComponent<Props> = ({ exercise, state, index, link }) => {
  return (
    <Link href={link} passHref>
      <a
        className={classNames('group rounded-lg relative shadow overflow-hidden border-4', {
          'border-green-600 bg-gray-100': state === 'done',
          'border-gray-600 bg-gray-200': state === 'undone',
        })}
      >
        <div className="px-6 py-4 sm:px-6 relative">
          <p className="text-lg font-medium text-gray-900 my-2">#{index}</p>
          <h3 className="text-xl font-medium text-gray-900 my-2">{exercise?.title}</h3>
          <div className="absolute top-2 right-2">
            <div
              className={classNames('h-6 w-6', {
                'text-green-600': state === 'done',
                'text-gray-500': state === 'undone',
              })}
            >
              {state === 'done' && <CheckCircleIcon />}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default CardExercise;
